import React, { useEffect, useState } from "react";

// reactstrap components
import {
	Card,
	CardHeader,
	CardBody,
	FormGroup,
	Table,
	Row,
	Col,
	Button,
	Collapse,
	Input,
	Label
} from "reactstrap";
import { Link } from "react-router-dom";
import * as moment from "moment";

import { STATUS_LIST, DATE_FORMATS, PAGE_LIMIT, MESSAGES } from '../../configs/constant'

import { GRAM_PANCHAYAT, STATES, DISTRICTS, BLOCKS } from '../../configs/urls'
import { getApi, deleteApi } from '../../services/api'

import Loader from '../../components/Loader'
import Toaster from "../../components/Toaster";

import './styles.css'
import { FaEdit } from 'react-icons/fa'
import axios from 'axios'

const GramPanchayats = () => {

	const [isRequesting, setIsRequesting] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [canShowLoadMore, setCanShowLoadMore] = useState(false);
	const [isFilterOpen, setIsFilterOpen] = useState(false)

	const [gramPanchayats, setGramPanchayats] = useState([])
	const [filterParams, setFilterParams] = useState({
		page: 0,
		size: PAGE_LIMIT,
		state_id: 20
	})
	const [states, setStates] = useState([])
	const [districts, setDistricts] = useState([])
	const [blocks, setBlocks] = useState([])

	useEffect(() => {
		getAllData()
	}, [])

	const getAllData = () => {
		setIsRequesting(true);

		const states = getApi(STATES);
		const districts = getApi(DISTRICTS, filterParams.state_id);
		const blocks = getApi(BLOCKS);
		const gramPanchayat = getApi(GRAM_PANCHAYAT, filterParams)

		axios
			.all([states, districts, blocks, gramPanchayat])
			.then((res) => {

				if (res[0] && res[0].data) {
					setStates(res[0].data)
				}

				if (res[1] && res[1].data) {
					setDistricts(res[1].data)
				}

				if (res[2] && res[2].data) {
					setBlocks(res[2].data)
				}

				if (res[3] && res[3].data) {
					setGramPanchayats(res[3].data || [])
					setCanShowLoadMore(res[3].data.length < res[3].meta.total)
				}
			})
			.catch(() => {

			}).finally(() => {
				setIsRequesting(false)
			})
	};

	const fetchGramPanchayat = (isLoadMore) => {
		const params = JSON.parse(JSON.stringify(filterParams))

		setIsLoading(true);
		for (const key in params) {
			if ((!params[key] && params[key] != 0) || params[key] == -1) {
				delete params[key]
			}
		}

		getApi(GRAM_PANCHAYAT, params)
			.then((res) => {
				let gpsData = isLoadMore ? [...gramPanchayats, ...res.data] : res.data;
				setGramPanchayats(gpsData || []);
				setCanShowLoadMore(gpsData.length < res.meta.total)
			}, (err) => {
				console.log(err);
			}).finally(() => {
				setIsLoading(false);
			})
	}

	const deleteGP = (gpID) => {
		var proceed = window.confirm("Are you sure you want to delete Gram Panchayat?");
		if (proceed) {
			deleteApi(`${GRAM_PANCHAYAT}/${gpID}`)
				.then((res) => {
					let list = gramPanchayats
					list = list.filter(item => item.id != gpID)
					setGramPanchayats(list)
					Toaster.showSuccess(res.message || 'District deleted successfully.')
				}, (err) => {
					Toaster.showError(err.message)
				})
		}
	}

	const handleChange = (event) => {
		event.persist();
		setFilterParams(values => ({ ...values, [event.target.name]: event.target.value }));
	};

	const resetFilter = () => {
		setFilterParams({
			state_id: -1,
			district_id: -1,
			block_id: -1,
			status: -1,
			name: '',
			page: 0,
			size: PAGE_LIMIT
		});

		fetchGramPanchayat();
	}

	
	const searchGps = () => {
		const params = filterParams;
		params.page = 0;

		setFilterParams(params)

		fetchGramPanchayat();
	}

	const loadMoreGps = () => {
		const params = filterParams;
		params.page++;

		setFilterParams(params)

		fetchGramPanchayat(true);
	}

	const getDistricts = (stateId) => {
		setIsLoading(true);

		setFilterParams({...filterParams, district_id: -1});
		setFilterParams({...filterParams, block_id: -1});

		getApi(DISTRICTS, { state_id: stateId }).then(res => {
			setDistricts(res.data)
		}).catch(() => { }).finally(() => {
			setIsLoading(false)
		})
	}

	const getBlocks = (districtId, stateId) => {
		setIsLoading(true);
		setFilterParams({...filterParams, block_id: -1});

		getApi(BLOCKS, { district_id: districtId, state_id: stateId }).then(res => {
			setBlocks(res.data)
		}).catch(() => { }).finally(() => {
			setIsLoading(false)
		})
	}


	const renderGps = () => (
		<div className="content">
			<Row>
				<Col md="12">
					<Card>
						<CardHeader className="header-section">
							<div>
								<Button color="primary" onClick={() => setIsFilterOpen(!isFilterOpen)}>Filter</Button>
							</div>
							<Link to="gram_panchayat/operations">
								<Button color="primary" className="text-right">Add New Gram Panchayat</Button>
							</Link>
						</CardHeader>

						<Collapse isOpen={isFilterOpen} className="border-top">
							<Card>
								<CardBody>
									<Row>
										<Col className="pr-1" md="4">
											<FormGroup>
												<Label for="stateName">State</Label>
												<Input
													type="select"
													name="state_id"
													value={filterParams.state_id}
													onChange={(e) => {
														getDistricts(e.target.value)
														handleChange(e)
													}}
												>
													<option value={-1}>Select State</option>
													{
														states.map(state => (
															<option key={state.id} value={state.id}>{state.name}</option>
														))
													}
												</Input>
											</FormGroup>
										</Col>
										<Col className="pl-1" md="4">
											<FormGroup>
												<Label for="districtName">District</Label>
												<Input
													type="select"
													name="district_id"
													value={filterParams.district_id}
													onChange={(e) => {
														getBlocks(e.target.value, filterParams.state_id)
														handleChange(e)
													}}
												>
													<option value={-1}>Select District</option>
													{
														districts.map(district => (
															<option key={district.id} value={district.id}>{district.name}</option>
														))
													}
												</Input>
											</FormGroup>
										</Col>
										<Col className="pr-1" md="4">
											<FormGroup>
												<Label for="stateName">Block</Label>
												<Input
													type="select"
													name="block_id"
													value={filterParams.block_id}
													onChange={handleChange}
												>
													<option value={-1}>Select Block</option>
													{
														blocks.map(block => (
															<option key={block.id} value={block.id}>{block.name}</option>
														))
													}
												</Input>
											</FormGroup>
										</Col>
									</Row>
									<Row>
										<Col className="pr-1" md="4">
											<FormGroup>
												<label>Gram Panchayat</label>
												<Input
													type="text"
													name="name"
													placeholder="Gram Panchayat Name"
													value={filterParams.name || ""}
													onChange={handleChange}
												/>
											</FormGroup>
										</Col>
										<Col className="pr-1" md="4">
											<FormGroup>
												<Label for="status">Status</Label>
												<Input
													type="select"
													name="status"
													value={filterParams.status}
													onChange={handleChange}
												>
													{
														STATUS_LIST.map(status => (
															<option key={status.id} value={status.id}>{status.title}</option>
														))
													}
												</Input>
											</FormGroup>
										</Col>
										<Col className="pr-1" md="4">
											<div className="update ml-auto mt-3 mr-auto">
												<Button className="btn-round" onClick={() => searchGps()} color="primary">
													Search
												</Button>
												<Button className="btn-round ml-2" onClick={() => resetFilter()} color="primary">
													Reset
												</Button>
											</div>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Collapse>

						<hr />

						<CardBody>
							<Table>
								<thead className="text-primary">
									<tr>
										<th>ID</th>
										<th>Gram Panchayat Name</th>
										<th>Block</th>
										<th>District</th>
										<th>State</th>
										<th>Status</th>
										<th>Last Update</th>
										<th className="text-right">Actions</th>
									</tr>
								</thead>
								<tbody>
									{
										gramPanchayats.map((gp, idx) => (
											<tr key={idx}>
												<td>{gp.id}</td>
												<td>{gp.name || '--'}</td>
												<td>{gp.block ? gp.block.name : '--'}</td>
												<td>{gp.district ? gp.district.name : '--'}</td>
												<td>{gp.state ? gp.state.name : '--'}</td>
												<td>{gp.status == 1 ? 'Enabled' : 'Disabled'}</td>
												<td>{gp.updated_at ? moment(gp.updated_at).format(DATE_FORMATS.DATE_TIME_FORMAT) : '--'}</td>
												<td className="text-right action-icons">
													<Link to={`gram_panchayat/operations/${gp.id}`}>
														<FaEdit />
													</Link>
												</td>
											</tr>
										))
									}
								</tbody>
							</Table>
							{
								gramPanchayats.length == 0 &&
								<span className="no-record-found">{MESSAGES.NO_RECORD_FOUND}</span>
							}
						</CardBody>
					</Card>
				</Col>
			</Row>
			{
				canShowLoadMore && 
				<Row>
					<Col className="load-more-col">
						<Button className="action-btn" onClick={() => loadMoreGps()} color="primary">Load more</Button>
					</Col>
				</Row>
			}
			<Loader isLoading={isLoading} />
		</div>
	)

	return (
		<>
			{
				isRequesting
					? <div className="content"><Loader isLoading={isRequesting} /></div>
					: renderGps()
			}
		</>
	);
}

export default GramPanchayats;
